class BlogPostSection {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.slideshow = null;
    this.mobileBreakpoint = 768;
    this.init();
  }

  init() {
    setTimeout(() => {
      this.initializeSlideshow();
      this.setupMobileGridSlideshow();
      this.setupResponsiveGridCols();
      this.bindEvents();
    }, 100);
  }

  initializeSlideshow() {
    const swiperContainer = this.container.querySelector('.blog-post__slideshow');
    if (!swiperContainer) return;

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded');
      return;
    }

    if (this.slideshow) {
      this.slideshow.destroy(true, true);
      this.slideshow = null;
    }

    const wrapper = this.container.querySelector('.blog-post-products-wrapper');
    const desktopPosts = parseInt(wrapper?.dataset.desktopProducts) || 3;
    const mobilePosts = parseInt(wrapper?.dataset.mobileProducts) || 1;

    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const slidesCount = slides.length;

    const swiperOptions = {
      slidesPerView: mobilePosts,
      spaceBetween: 20,
      slidesPerGroup: 1,
      navigation: {
        nextEl: this.container.querySelector('.blog-post__slideshow-next'),
        prevEl: this.container.querySelector('.blog-post__slideshow-prev'),
      },
      pagination: {
        el: this.container.querySelector('.blog-post__slideshow-pagination-progressbar'),
        type: "progressbar",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        450: {
          slidesPerView: mobilePosts,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: desktopPosts,
          spaceBetween: 24,
        } 
      },
      autoplay: false,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      centeredSlides: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      resizeObserver: true,
      updateOnWindowResize: true,
      init: true,
      on: {
        init: function() {
          this.slides.forEach(slide => {
            slide.style.width = '';
            slide.style.marginRight = '';
          });
          this.update();
        },
        resize: function() {
          this.slides.forEach(slide => {
            slide.style.width = '';
            slide.style.marginRight = '';
          });
          this.update();
        }
      }
    };

    try {
      this.slideshow = new Swiper(swiperContainer, swiperOptions);
      
      setTimeout(() => {
        if (this.slideshow) {
          this.slideshow.update();
        }
      }, 50);
    } catch (error) {
    }
  }

  setupMobileGridSlideshow() {
    const gridContainer = this.container.querySelector('.blog-post-mobile-slideshow .blog-post__grid');
    if (!gridContainer) return;

    gridContainer.style.scrollSnapType = 'x mandatory';

    const gridItems = gridContainer.querySelectorAll('.blog-post__grid-item');
    gridItems.forEach(item => {
      item.style.scrollSnapAlign = 'start';
    });
  }

  setupResponsiveGridCols() {
    const gridContainer = this.container.querySelector('.blog-post__grid');
    if (!gridContainer) return;

    const desktopCols = gridContainer.dataset.desktopCols || 3;
    const mobileCols = gridContainer.dataset.mobileCols || 1;
    gridContainer.style.setProperty('--desktop-cols', desktopCols);
    gridContainer.style.setProperty('--mobile-cols', mobileCols);
  }

  bindEvents() {
    this.resizeHandler = this.debounce(() => {
      this.handleResize();
    }, 250);
    
    window.addEventListener('resize', this.resizeHandler);
  }

  handleResize() {
    if (this.slideshow) {
      this.slideshow.slides.forEach(slide => {
        slide.style.width = '';
        slide.style.marginRight = '';
      });
      this.slideshow.update();
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  destroy() {
    if (this.slideshow) {
      this.slideshow.destroy(true, true);
      this.slideshow = null;
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
}

const blogPostInstances = new Map();

document.addEventListener('DOMContentLoaded', () => {
  const blogPostSections = document.querySelectorAll('.blog-post-section');
  blogPostSections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const instance = new BlogPostSection(section);
    blogPostInstances.set(sectionId, instance);
  });
});

if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.blog-post-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (blogPostInstances.has(sectionId)) {
        blogPostInstances.get(sectionId).destroy();
      }
      const instance = new BlogPostSection(section);
      blogPostInstances.set(sectionId, instance);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.blog-post-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (blogPostInstances.has(sectionId)) {
        blogPostInstances.get(sectionId).destroy();
        blogPostInstances.delete(sectionId);
      }
    }
  });

  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target.querySelector('.blog-post-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = BlogPostSection;
}